// extracted by mini-css-extract-plugin
export default {"formItem":"DiscountInput_formItem__mBCpb","inputContainer":"DiscountInput_inputContainer__c2op2","input":"DiscountInput_input__GvyqB","button":"DiscountInput_button__lOiZy"};